const rankings = [
  { rank: 1, title: '我独自升级', type: '韩漫', tag: '热血·奇幻', change: 'up', desc: '韩漫现象级作品，全球累计阅读超百亿次' },
  { rank: 2, title: '咒术回战', type: '日漫', tag: '战斗·黑暗', change: 'same', desc: 'Jump台柱级作品，动画化后人气持续飙升' },
  { rank: 3, title: '天官赐福', type: '国漫', tag: '古风·仙侠', change: 'up', desc: '墨香铜臭原作改编，国漫排行榜常驻前三' },
  { rank: 4, title: '某天成为公主', type: '韩漫', tag: '恋爱·穿越', change: 'down', desc: '韩漫甜宠天花板，画风精美剧情引人入胜' },
  { rank: 5, title: '镖人', type: '国漫', tag: '历史·武侠', change: 'up', desc: '硬核国漫代表，中日同步连载的口碑神作' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">热门榜单</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">实时热度排行，发现当下最火的漫画</p>

        <div className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden">
          {rankings.map((r, i) => (
            <div
              key={i}
              className={`flex items-center gap-4 p-4 md:p-5 ${
                i < rankings.length - 1 ? 'border-b border-background-200/70' : ''
              }`}
            >
              <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 text-sm font-bold ${
                r.rank === 1 ? 'bg-primary-500 text-background-50' :
                r.rank === 2 ? 'bg-secondary-500 text-background-50' :
                r.rank === 3 ? 'bg-accent-500 text-background-50' :
                'bg-background-200 text-foreground-600'
              }`}>
                {r.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="text-sm font-medium text-foreground-800">{r.title}</h3>
                  <span className="text-xs px-1.5 py-0.5 rounded bg-background-200 text-foreground-500">{r.type}</span>
                  <span className="text-xs text-foreground-400">{r.tag}</span>
                </div>
                <p className="text-xs text-foreground-500 mt-1">{r.desc}</p>
              </div>

              <div className="flex-shrink-0">
                {r.change === 'up' && <i className="ri-arrow-up-fill text-sm text-primary-500" />}
                {r.change === 'down' && <i className="ri-arrow-down-fill text-sm text-accent-500" />}
                {r.change === 'same' && <i className="ri-subtract-line text-sm text-foreground-400" />}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}